var React = require('react');

function Dropdown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"fill":"#000000","fillRule":"evenodd","d":"M.90081.36992c-.23656.22086-.23656.5784 0 .79869l5.01579 4.6707c.47374.44114 1.24228.44114 1.71601 0l5.05279-4.70459c.2341-.2186.2372-.57162.0061-.79304-.236-.2265-.6248-.22876-.8644-.00621l-4.62334 4.3058c-.23717.22086-.62113.22086-.85831 0L1.75851.36992c-.23656-.22085-.62053-.22085-.8577 0z","clipRule":"evenodd","key":1})]);
}

Dropdown.defaultProps = {"fill":"none","viewBox":"0 0 14 7"};

module.exports = Dropdown;

Dropdown.default = Dropdown;
